import React from "react";
import { Helmet } from "react-helmet-async";
import { GOOGLE_LISTING_URL, SITE_URL, organization, programs } from "../seo/programs";

const navClearance = {
  neet: 64,
  jee: 64,
  keam: 64,
  "online-live-classes": 40,
  "tuition-only": 148,
  "tuition-entrance": 148,
  "entrance-only": 148,
  "foundation-skill": 148,
};

export default function ProgramSeo({ id }) {
  const program = programs[id];
  const padTop = navClearance[id] || 0;
  const canonical = `${SITE_URL}${program.path === "/" ? "/" : program.path}`;
  const jsonLd =
    id === "home"
      ? {
          "@context": "https://schema.org",
          ...organization,
          description: program.description,
        }
      : {
          "@context": "https://schema.org",
          "@type": "Course",
          name: program.heading,
          description: program.description,
          url: canonical,
          provider: organization,
        };

  return (
    <>
      <Helmet>
        <title>{program.title}</title>
        <meta name="description" content={program.description} />
        <link rel="canonical" href={canonical} />
        <meta property="og:title" content={program.title} />
        <meta property="og:description" content={program.description} />
        <meta property="og:url" content={canonical} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="KBS Academy" />
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Helmet>
      <div className="container" data-seo={id} style={padTop ? { paddingTop: padTop } : undefined}>
        <h2
          className="font-semibold transition duration-500"
          style={{ fontSize: "30px", marginBottom: "16px" }}
        >
          {program.heading}
        </h2>
        {program.paragraphs.map((paragraph) => (
          <p key={paragraph} className="text-slate-400 text-[16px] mb-4">
            {paragraph}
          </p>
        ))}
        <p className="text-slate-400 text-[16px] mb-4">
          <a
            href={GOOGLE_LISTING_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-violet-600 hover:text-violet-600"
          >
            KBS Academy Palakkad Town Campus on Google Maps
          </a>
        </p>
      </div>
    </>
  );
}
